import React from 'react';
import './Card.css';

const Card = ({ title, value, change, icon, type }) => {
  const cardIconClass = `card-icon ${type}`;
  
  return (
    <div className="card">
      <div className="card-header">
        <div className={cardIconClass}>
          <i className={`fas fa-${icon}`}></i>
        </div>
        <div className="card-percentage">
          <span style={{ color: change.startsWith('+') ? '#10b981' : '#ef4444' }}>
            {change}
          </span>
        </div>
      </div>
      <div className="card-title">{title}</div>
      <div className="card-value">{value}</div>
      <div className="card-footer">Compared to last month</div>
    </div>
  );
};

export default Card;